/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Waiting_Days_OneInputs */



/**
* | output |
* | --- |
* | "oldest waiting 1 day" |
*
* @param {Partner_Billing_Board_Waiting_Days_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_waiting_days_one = /** @type {((inputs?: Partner_Billing_Board_Waiting_Days_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Waiting_Days_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("ältester wartet seit 1 Tag")
	return /** @type {LocalizedString} */ ("oldest waiting 1 day")
});